export const latestUpdates = [
  { time: "09:41", text: "新增档案：L姓男歌手「演唱会假唱后拉黑粉丝」争议补充 3 条路人证言" },
  { time: "09:12", text: "避雷名单更新：短视频顶流主播·某团的避雷指数由 62 上调至 78" },
  { time: "08:47", text: "脱粉现场：超话前管理员发长文，说明「粉丝回踩」的完整时间线" },
  { time: "08:15", text: "话题墙新增标签：商务翻车 / 立人设反噬 / 内部群爆料" },
  { time: "07:52", text: "人品盘点：W姓选秀爱豆「私下态度」相关讨论热度进入本周前五" },
  { time: "07:20", text: "路人反感点分析更新：为什么「卖惨式营业」最容易引发集体回踩" },
  { time: "06:58", text: "争议档案：某剧组合照抢位事件，双方粉丝说法已整理成对照表" },
  { time: "06:31", text: "提醒：所有内容均来自公开讨论整理，请理性看待，勿对号入座" },
];

export const navEntries = [
  { label: "更新条", href: "#updates" },
  { label: "话题墙", href: "#topics" },
  { label: "避雷名单", href: "#blacklist" },
  { label: "人品盘点", href: "#files" },
  { label: "脱粉现场", href: "#unfollow" },
  { label: "避雷自查", href: "#radar" },
];

export const heroStats = [
  { label: "在库人物档案", value: "1,246" },
  { label: "本周新增避雷记录", value: "68" },
  { label: "讨论帖 · 回踩样本", value: "9,830" },
  { label: "路人反感点条目", value: "312" },
];

export const topicGroups = [
  {
    key: "all",
    label: "全部话题",
    tags: [
      { label: "粉丝回踩", heat: 96, count: 1240 },
      { label: "商务翻车", heat: 88, count: 872 },
      { label: "立人设反噬", heat: 84, count: 806 },
      { label: "内部群爆料", heat: 79, count: 654 },
      { label: "演唱会假唱", heat: 76, count: 588 },
      { label: "社交媒体态度", heat: 71, count: 512 },
      { label: "售后与退款", heat: 64, count: 430 },
      { label: "代拍偷拍争议", heat: 58, count: 366 },
      { label: "控评与水军", heat: 55, count: 342 },
      { label: "私联粉丝", heat: 52, count: 318 },
      { label: "直播口误", heat: 44, count: 264 },
      { label: "团队公关手段", heat: 41, count: 232 },
    ],
  },
  {
    key: "music",
    label: "音乐 · 舞台",
    tags: [
      { label: "演唱会假唱", heat: 76, count: 588 },
      { label: "抢话筒", heat: 48, count: 210 },
      { label: "舞台敷衍", heat: 46, count: 198 },
      { label: "歌单缩水", heat: 39, count: 164 },
      { label: "票务加价", heat: 61, count: 288 },
    ],
  },
  {
    key: "live",
    label: "直播 · 带货",
    tags: [
      { label: "商务翻车", heat: 88, count: 872 },
      { label: "售后与退款", heat: 64, count: 430 },
      { label: "直播口误", heat: 44, count: 264 },
      { label: "夸大宣传", heat: 70, count: 502 },
      { label: "拉黑用户", heat: 57, count: 356 },
    ],
  },
  {
    key: "team",
    label: "团队 · 公关",
    tags: [
      { label: "控评与水军", heat: 55, count: 342 },
      { label: "团队公关手段", heat: 41, count: 232 },
      { label: "私联粉丝", heat: 52, count: 318 },
      { label: "内部群爆料", heat: 79, count: 654 },
    ],
  },
];

export const blacklistBoards = [
  {
    key: "total",
    label: "综合避雷",
    entries: [
      {
        rank: "01",
        name: "短视频顶流主播·某团",
        identity: "直播带货 / 千万级粉丝",
        reason: "选品与售后口径前后不一致，粉丝回踩后仍以「流程问题」回应",
        heat: 78,
        tags: ["商务翻车", "售后与退款"],
      },
      {
        rank: "02",
        name: "L姓男歌手（选秀出身）",
        identity: "歌手 / 巡演常客",
        reason: "被指现场假唱并以拉黑方式处理质疑，路人反感点集中在态度",
        heat: 74,
        tags: ["演唱会假唱", "社交媒体态度"],
      },
      {
        rank: "03",
        name: "W姓选秀爱豆",
        identity: "偶像 / 团内主唱",
        reason: "私下对待工作人员的态度被多次提及，与公开人设落差较大",
        heat: 69,
        tags: ["立人设反噬", "内部群爆料"],
      },
      {
        rank: "04",
        name: "剧集演员·H 某",
        identity: "演员 / 剧集主角",
        reason: "剧组宣传期抢位与采访改稿争议，团队控评痕迹明显",
        heat: 63,
        tags: ["控评与水军", "团队公关手段"],
      },
      {
        rank: "05",
        name: "生活区博主·阿某",
        identity: "生活方式 / 中腰部",
        reason: "内容与商单边界模糊，被指「种草即广告」且未做标注",
        heat: 57,
        tags: ["商务翻车", "夸大宣传"],
      },
      {
        rank: "06",
        name: "独立音乐人·Z 某",
        identity: "独立音乐 / 小场地巡演",
        reason: "开演时长缩水、歌单临场变动，退票沟通周期过长",
        heat: 51,
        tags: ["歌单缩水", "售后与退款"],
      },
    ],
  },
  {
    key: "recent",
    label: "近期新增",
    entries: [
      {
        rank: "01",
        name: "W姓选秀爱豆",
        identity: "偶像 / 团内主唱",
        reason: "本周新增 5 条现场态度相关证言，讨论量翻倍",
        heat: 72,
        tags: ["立人设反噬", "内部群爆料"],
      },
      {
        rank: "02",
        name: "短剧演员·小某",
        identity: "短剧 / 快速走红",
        reason: "被指拍摄期使用替身却全程宣传「亲自上阵」",
        heat: 66,
        tags: ["立人设反噬", "夸大宣传"],
      },
      {
        rank: "03",
        name: "音乐主播·米某",
        identity: "翻唱主播 / 直播常播",
        reason: "直播间拉黑提问用户，事后在动态中隐去关键信息",
        heat: 58,
        tags: ["拉黑用户", "社交媒体态度"],
      },
    ],
  },
  {
    key: "steady",
    label: "持续在榜",
    entries: [
      {
        rank: "01",
        name: "短视频顶流主播·某团",
        identity: "直播带货 / 千万级粉丝",
        reason: "连续 6 周在榜，商务争议不断但回应方式始终未变",
        heat: 78,
        tags: ["商务翻车", "售后与退款"],
      },
      {
        rank: "02",
        name: "L姓男歌手（选秀出身）",
        identity: "歌手 / 巡演常客",
        reason: "已满 8 周在榜，路人反感点集中在「沟通方式」",
        heat: 74,
        tags: ["演唱会假唱", "社交媒体态度"],
      },
      {
        rank: "03",
        name: "剧集演员·H 某",
        identity: "演员 / 剧集主角",
        reason: "在榜 4 周，公关动作反复但口碑回升有限",
        heat: 63,
        tags: ["控评与水军", "团队公关手段"],
      },
    ],
  },
];

export const characterFiles = [
  {
    name: "某团",
    identity: "直播带货主播",
    initial: "某",
    issue: "临时改价、赠品缩水，粉丝群管理员被要求统一话术",
    stance: "避雷范围：直接下单类消费",
    status: "持续争议",
    updated: "今天 09:12",
    count: 214,
  },
  {
    name: "L姓男歌手",
    identity: "选秀出身歌手",
    initial: "L",
    issue: "巡演现场被指假唱，质疑评论被批量删除与拉黑",
    stance: "避雷范围：线下演出购票",
    status: "热度上升",
    updated: "今天 09:41",
    count: 186,
  },
  {
    name: "W姓爱豆",
    identity: "团内主唱",
    initial: "W",
    issue: "对待随行人员的态度与台上人设反差被反复提及",
    stance: "避雷范围：长期追星投入",
    status: "新增证言",
    updated: "今天 08:47",
    count: 152,
  },
  {
    name: "H某",
    identity: "剧集演员",
    initial: "H",
    issue: "宣传期采访改稿与合影排序争议，控评痕迹明显",
    stance: "避雷范围：站子集资应援",
    status: "已回应",
    updated: "昨天 22:10",
    count: 118,
  },
  {
    name: "阿某",
    identity: "生活区博主",
    initial: "阿",
    issue: "商单内容未标注，被指「种草即广告」",
    stance: "避雷范围：推荐类消费",
    status: "观察中",
    updated: "昨天 19:36",
    count: 96,
  },
  {
    name: "Z某",
    identity: "独立音乐人",
    initial: "Z",
    issue: "开演时长缩水，退票沟通周期长",
    stance: "避雷范围：小场地演出",
    status: "热度下降",
    updated: "前天 15:02",
    count: 74,
  },
];

export const unfollowPosts = [
  {
    author: "前·超话三号管理员",
    initial: "管",
    title: "从内部群到脱粉：我为什么选择回踩，而不是沉默",
    excerpt:
      "整理了一份完整时间线。不是不能接受他状态不好，而是不能接受每次出问题，都由粉丝去替他对抗全世界。",
    tags: ["粉丝回踩", "内部群爆料"],
    replies: 386,
    likes: 1240,
    time: "12 分钟前",
    hot: true,
  },
  {
    author: "追了四年线下的人",
    initial: "线",
    title: "连看三场巡演，我把票根全部剪了",
    excerpt:
      "第一场以为是设备问题，第二场开始确认是固定段落。最难受的是提出来的人会被挂出来骂。",
    tags: ["演唱会假唱", "社交媒体态度"],
    replies: 254,
    likes: 908,
    time: "40 分钟前",
    hot: true,
  },
  {
    author: "买过六次团购的路人",
    initial: "路",
    title: "售后是我脱粉的最后一根稻草",
    excerpt:
      "东西出问题可以理解，但客服话术一次比一次冷漠，最后只给了一句「流程如此」。",
    tags: ["商务翻车", "售后与退款"],
    replies: 173,
    likes: 612,
    time: "1 小时前",
    hot: false,
  },
  {
    author: "剧组外场跟过三次",
    initial: "组",
    title: "我看到的排序，和通稿里写的完全不一样",
    excerpt:
      "现场其实很安静，真正让人下头的是团队后续的处理方式，把提意见的人当成了敌人。",
    tags: ["团队公关手段", "控评与水军"],
    replies: 141,
    likes: 486,
    time: "2 小时前",
    hot: false,
  },
  {
    author: "从粉丝变成围观者",
    initial: "围",
    title: "脱粉不等于黑，我只是想提醒后来的人",
    excerpt:
      "写这条路不是为了骂谁，是希望还有人可以在投入大量时间和钱之前，先看看这些公开讨论。",
    tags: ["粉丝回踩", "路人反感点"],
    replies: 208,
    likes: 730,
    time: "3 小时前",
    hot: false,
  },
];

export const radarPoints = [
  {
    level: "高频",
    title: "卖惨式营业",
    desc: "用情绪代替解释，把争议转成「我很难」，最容易引发集体回踩。",
  },
  {
    level: "高频",
    title: "拉黑代替回应",
    desc: "面对质疑第一时间清评论、拉黑账号，通常说明问题并不在沟通方式上。",
  },
  {
    level: "中频",
    title: "人设与私下反差",
    desc: "公开形象越完美，一旦出现现场目击类说法，落差感就越难挽回。",
  },
  {
    level: "中频",
    title: "商务与内容边界模糊",
    desc: "以「个人分享」口吻发布的推荐，往往是未标注的商单。",
  },
  {
    level: "观察项",
    title: "团队控评节奏",
    desc: "短时间内口径统一、话术高度一致，通常不是自然形成的讨论。",
  },
  {
    level: "观察项",
    title: "售后与退款态度",
    desc: "争议出现后第一时间看售后口径，比看声明更能判断长期态度。",
  },
];

export const selfCheckItems = [
  "是否只是单次情绪化爆料，缺乏可核对的细节？",
  "说法是否来自公开讨论，而非私人聊天截图？",
  "争议出现后，对方的回应方式是否比事件本身更值得留意？",
  "我是否因为投入太多时间与金钱，才不愿意承认看错？",
  "在转发之前，我是否愿意把语气调整成「提醒」而不是「审判」？",
];

export const footerColumns = [
  {
    title: "站内分区",
    links: ["实时更新条", "话题墙", "避雷名单", "人品盘点", "脱粉现场"],
  },
  {
    title: "使用指南",
    links: ["如何看避雷指数", "如何提交线索", "讨论区规则", "代号说明"],
  },
  {
    title: "关于本站",
    links: ["站点说明", "免责声明", "内容纠错入口", "联系与反馈"],
  },
];

export const footerStatement = [
  { label: "内容来源", value: "公开讨论整理" },
  { label: "更新时间", value: "每 30 分钟" },
  { label: "处理原则", value: "去标识化 · 可纠错" },
];